import React, { Component } from 'react';
import { connect } from 'react-redux';
import './ProjectMeetingMinutes.css';
import { setShowEmailModal } from 'components/admin/projects/details/project-email-modal/store/actions';
import { getShowEmailModal } from 'components/admin/projects/details/project-email-modal/store/selectors';
import { sendProjectResourceEmails } from 'components/admin/projects/details/store/actions';
import ProjectEmailModal from 'components/admin/projects/details/project-email-modal/ProjectEmailModal';
import { Modal } from 'react-bootstrap';
import SimpleTable from 'components/shared/table/SimpleTable';
import Button from 'components/shared/button/Button';
import ConfirmationPanel from 'components/shared/confirmation/ConfirmationPanel';
import checkCirclePng from 'images/check-circle.png';
import { getNotifications } from 'selectors/notifications';
import { unreadNotifications } from 'domain/notification';
import { getCurrentProject } from 'components/admin/projects/details/store/selectors';
import {
  getMeetingInfo,
  getMeetingInfoEdit,
  getMeetings,
  getMeetingModalShow,
  getMeetingPdf,
  getShowPdfViewer,
  getConfirmationMsg,
  getCurrentMeeting,
} from 'components/admin/projects/details/project-meeting-minutes/store/selectors';
import {
  initMeetingMinutes,
  loadMeetingInfoRequest,
  setMeetingInfoEdit,
  createMeetingInfo,
  updateMeetingInfo,
  loadMeetingsRequest,
  setMeetingModalShow,
  setCurrentMeeting,
  loadMeetingPdfRequest,
  togglePdfViewer,
  setConfirmationMsg,
  openMeeting,
  deleteMeetingRequest,
} from 'components/admin/projects/details/project-meeting-minutes/store/actions';
import MeetingInfo from 'components/admin/projects/details/project-meeting-minutes/MeetingInfo';
import Date from 'components/shared/text/Date';
import { formatPhoneNumber } from 'services/utils/text-util';
import BaseStatus from 'components/shared/text/BaseStatus';
import MeetingModal from 'components/admin/projects/details/project-meeting-minutes/MeetingModal';
import { getCurrentUser } from 'selectors/authentication';
import { Enterprise } from 'domain/enterprise';
import { MeetingStatusEnum } from 'domain/meeting-status-enum';
import { markNotifiableNotificationsAsRead } from 'actions/notifications';
import PdfViewer from 'components/shared/pdf-viewer/PdfViewer';

class ProjectMeetingMinutes extends Component {
  constructor(props) {
    super(props);

    props.dispatch(initMeetingMinutes());
  }

  componentDidMount() {
    if (this.props.currentProject) {
      this.props.dispatch(loadMeetingInfoRequest(this.props.currentProject.id));
      this.props.dispatch(loadMeetingsRequest(this.props.currentProject.id));
    }
  }

  showActions = () => {
    const contribType = this.props.currentProject.contributor_type;
    return (
      Enterprise.spackle(contribType) ||
      Enterprise.generalContractor(contribType) ||
      Enterprise.primary(contribType)
    );
  };

  primary = () => {
    const contribType = this.props.currentProject.contributor_type;
    return Enterprise.primary(contribType);
  };

  handleEditMeetingInfo = () => {
    this.props.dispatch(setMeetingInfoEdit(true));
  };

  handleViewPdf = (meetingId) => {
    this.props
      .dispatch(loadMeetingPdfRequest(this.props.currentProject.id, meetingId))
      .then((response) => {
        if (response.ok) {
          this.props.dispatch(togglePdfViewer());
        }
      });
  };

  handlePdfViewerClose = () => {
    this.props.dispatch(togglePdfViewer());
  };

  handleSubmitMeetingInfo = (values) => {
    let promise = null;
    if (this.props.meetingInfo) {
      promise = this.props.dispatch(
        updateMeetingInfo(this.props.currentProject.id, values)
      );
    } else {
      promise = this.props.dispatch(
        createMeetingInfo(this.props.currentProject.id, values)
      );
    }

    promise.then((response) => {
      if (response.ok) {
        this.props.dispatch(setMeetingInfoEdit(false));
      }
    });
  };

  handleCancelMeetingInfo = () => {
    this.props.dispatch(setMeetingInfoEdit(false));
  };

  handleShowEmailModal = (meeting) => {
    this.props.dispatch(setCurrentMeeting(meeting));
    this.props.dispatch(setShowEmailModal(true));
  };

  handleSendEmail = (emailsData) => {
    this.props.dispatch(
      sendProjectResourceEmails(
        this.props.currentMeeting.id,
        'Meeting',
        emailsData
      )
    );
  };

  buildEmailModalTitle = () => {
    const { currentProject, currentMeeting } = this.props;
    return `Meeting #${currentMeeting.number} (Project #${currentProject.number}: ${currentProject.name})`;
  };

  buildEmailModalSubject = () => {
    const { currentProject, currentMeeting } = this.props;
    return `${currentProject.number}, ${currentProject.name} - Meeting ${currentMeeting.number}`;
  };

  buildEmailModalMessage = () => {
    const { currentProject, currentMeeting } = this.props;
    let location = '';
    if (currentProject.building && currentProject.building.location) {
      const buildingLocation = currentProject.building.location;
      location = ` at ${buildingLocation.street_address_1}, ${buildingLocation.city} ${buildingLocation.state}`;
    }

    return `Please find the attached Meeting #${currentMeeting.number} for Project ${currentProject.name}${location}. If you have any questions, please reach out via chat or email.`;
  };

  handleGenerateLink = (index) => {
    const { meetings } = this.props;
    return `?meetingId=${meetings[index].id}`;
  };

  isMeetingDeletable = (meeting) => {
    const { currentProject, meetings } = this.props;
    return (
      meeting.id === meetings[meetings.length - 1].id &&
      (meeting.status !== 'approved' ||
        Enterprise.spackle(currentProject.contributor_type))
    );
  };

  mapMeetings = () => {
    const unreadById = unreadNotifications(this.props.notifications, 'Meeting');
    return this.props.meetings.map((meeting) => {
      const submittedBy = meeting.submitted_by;
      const meetingStatusEnum = MeetingStatusEnum.create(meeting.status);
      const statusLabel = meetingStatusEnum.label;
      const draftMeeting = MeetingStatusEnum.DRAFT.equals(meetingStatusEnum);
      const unread = unreadById && !!unreadById[meeting.id];
      return [
        <div>
          {unread && (
            <BaseStatus
              labels={[
                {
                  id: 'unread',
                  label: '',
                },
              ]}
              status="unread"
            />
          )}
          {meeting.number}
        </div>,
        <Date value={meeting.meeting_date} format="MM/DD/YYYY" />,
        meeting.summary || `Meeting Minutes ${meeting.number}`,
        submittedBy
          ? `${submittedBy.first_name} ${submittedBy.last_name}${
              submittedBy.title ? ` - ${submittedBy.title}` : ''
            }`
          : '-',
        <div className={draftMeeting ? 'draft' : ''}>
          {statusLabel.charAt(0).toUpperCase()}
          {statusLabel.slice(1)}
        </div>,
        meeting.approved_at ? (
          <Date value={meeting.approved_at} format="MM/DD/YYYY" />
        ) : (
          '-'
        ),
        <a
          className="action-link"
          onClick={() => this.handleShowEmailModal(meeting)}
        >
          Email
        </a>,
        <a
          className="action-link"
          onClick={() => this.handleViewPdf(meeting.id)}
        >
          PDF
        </a>,
        <a
          className="action-link"
          onClick={() => this.handleViewDetails(meeting.id)}
        >
          Open
        </a>,
        this.isMeetingDeletable(meeting) && (
          <a
            className="action-link"
            onClick={() => this.handleDeleteMeeting(meeting.id)}
          >
            Delete
          </a>
        ),
      ];
    });
  };

  handleAddMeeting = () => {
    this.props.dispatch(setCurrentMeeting(null));
    this.props.dispatch(setMeetingModalShow(true));
  };

  handleViewDetails = (meetingId) => {
    const { currentProject, dispatch } = this.props;
    dispatch(openMeeting(currentProject.id, meetingId));
    dispatch(markNotifiableNotificationsAsRead(meetingId, 'Meeting'));
  };

  handleDeleteMeeting = (meetingId) => {
    const confirmed = window.confirm('Are you sure?');
    confirmed &&
      this.props
        .dispatch(deleteMeetingRequest(this.props.currentProject.id, meetingId))
        .then((response) => {
          if (response.ok) {
            this.props.dispatch(
              loadMeetingsRequest(this.props.currentProject.id)
            );
          }
        });
  };

  handleConfirm = () => {
    this.props.dispatch(setConfirmationMsg(''));
    this.props.dispatch(setMeetingModalShow(false));
  };

  render() {
    const { currentProject } = this.props;
    const showActions = currentProject && this.showActions();
    const primary = currentProject && this.primary();
    let initialMeetingInfoValues = {};
    if (this.props.meetingInfo) {
      initialMeetingInfoValues = {
        dayOfWeek: this.props.meetingInfo.day_of_week,
        startsAt: this.props.meetingInfo.starts_at,
        endsAt: this.props.meetingInfo.ends_at,
        timeZone: this.props.meetingInfo.time_zone,
        meetingLocation: this.props.meetingInfo.meeting_location,
        siteWalk: this.props.meetingInfo.site_walk,
        phoneNumber: formatPhoneNumber(this.props.meetingInfo.phone_number),
        code: this.props.meetingInfo.code,
        hostPin: this.props.meetingInfo.host_pin,
        webLink: this.props.meetingInfo.web_link,
      };
    }

    return (
      currentProject && (
        <div className="project-meeting-minutes">
          <MeetingInfo
            meetingInfoEdit={this.props.meetingInfoEdit}
            initialMeetingInfoValues={initialMeetingInfoValues}
            meetingInfo={this.props.meetingInfo}
            showActions={showActions}
            handleSubmitMeetingInfo={this.handleSubmitMeetingInfo}
            handleCancelMeetingInfo={this.handleCancelMeetingInfo}
            handleEditMeetingInfo={this.handleEditMeetingInfo}
          />

          <hr className="project-meeting-minutes-divider" />

          <div className="meeting-minutes">
            <div className="meeting-minutes-header">
              <h3>Meeting Minutes</h3>
              {showActions && (
                <Button
                  className="button-orange"
                  label="Add Meeting"
                  onClick={this.handleAddMeeting}
                />
              )}
            </div>
            <SimpleTable
              className="projects-table meeting-minutes-table"
              headers={[
                '#',
                'MEETING DATE',
                'TITLE',
                'SUBMITTED BY',
                'STATUS',
                'PUBLISHED',
                '',
                'ACTIONS',
                '',
                '',
              ]}
              rows={this.mapMeetings()}
              emptyMessage="No meetings Added"
              onGenerateLink={this.handleGenerateLink}
            />
          </div>

          <PdfViewer
            content={{
              source: this.props.meetingPdf,
              type: 'blob',
            }}
            show={this.props.showPdfViewer}
            onClose={this.handlePdfViewerClose}
          />

          {this.props.meetingModalShow && (
            <MeetingModal showActions={showActions} primary={primary} />
          )}

          {this.props.confirmationMsg && (
            <Modal show={!!this.props.confirmationMsg}>
              <ConfirmationPanel
                image={checkCirclePng}
                firstLine="Thank you!"
                lines={[this.props.confirmationMsg]}
                buttons={[
                  <Button
                    className="button-orange"
                    label="Continue"
                    onClick={this.handleConfirm}
                  />,
                ]}
              />
            </Modal>
          )}

          {this.props.showEmailModal && (
            <ProjectEmailModal
              title={this.buildEmailModalTitle()}
              handleSendEmail={this.handleSendEmail}
              projectId={this.props.currentProject.id}
              initialSubject={this.buildEmailModalSubject()}
              initialMessage={this.buildEmailModalMessage()}
            />
          )}
        </div>
      )
    );
  }
}

export default connect((state) => {
  return {
    currentProject: getCurrentProject(state),
    meetingInfo: getMeetingInfo(state),
    meetingInfoEdit: getMeetingInfoEdit(state),
    meetings: getMeetings(state),
    meetingModalShow: getMeetingModalShow(state),
    currentUser: getCurrentUser(state),
    showPdfViewer: getShowPdfViewer(state),
    meetingPdf: getMeetingPdf(state),
    confirmationMsg: getConfirmationMsg(state),
    notifications: getNotifications(state),
    showEmailModal: getShowEmailModal(state),
    currentMeeting: getCurrentMeeting(state),
  };
})(ProjectMeetingMinutes);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-meeting-minutes/ProjectMeetingMinutes.js